import { TemplateEngine } from "../../utils/TemplateEngine.js";
import { AppConfig } from "../../utils/AppConfig.js";
import { ApiService } from "../../utils/ApiService.js";
import { getNombre, getUrlFoto, CAMBIAR_CLAVE_URL } from "../../services/LcapiiService.js";
import navbarTemplate from "./navbar.html?raw";
import Swal from "sweetalert2";

export const Navbar = {
  // active: "inventarios" | "muestreos"
  render: (active = "") => {
    const apiUrl = AppConfig.resolvedApiUrl();
    return TemplateEngine.render(navbarTemplate, {
      appName: AppConfig.app.name,
      invActive: active === "inventarios",
      musActive: active === "muestreos",
      apkUrl: apiUrl + "/descargar-apk",
      perfilUrl: apiUrl + "/descargar-perfil",
      excelUrl: apiUrl + "/Excel-Reporte.xlsm",
      usuario: getNombre(),
      urlFoto: getUrlFoto(),
      cambiarClaveUrl: CAMBIAR_CLAVE_URL,
      skipLogin: AppConfig.lcapii.skipLogin,
    });
  },

  // El usuario entró a LCApii pero no tiene el permiso "Ingresar" de este sistema.
  renderSinAcceso: () => {
    document.getElementById("app").innerHTML =
      '<div class="sin-acceso">' +
      '<img src="/logo-casadelaudio.png" alt="Casa del Audio" />' +
      "<h1>Sin acceso</h1>" +
      "<p><b>" + Navbar.esc(getNombre()) + "</b>, tu usuario no tiene permiso para entrar al " +
      Navbar.esc(AppConfig.app.name) + ". Pedile el acceso a Sistemas.</p>" +
      '<a class="btn btn-primary" href="?s">Ingresar con otro usuario</a>' +
      "</div>";
  },

  // Llamar después de inyectar el navbar en el DOM.
  bind: () => {
    document.getElementById("navInfo")?.addEventListener("click", async (e) => {
      e.preventDefault();
      try {
        const info = await ApiService.get("info", null, { cacheTiempo: "30s" });
        const items = Array.isArray(info) ? info : [];
        const html = items.length
          ? "<ul class='text-start mb-0'>" + items.map((i) => "<li>" + Navbar.esc(i) + "</li>").join("") + "</ul>"
          : "<p class='mb-0'>Sin información disponible.</p>";
        Swal.fire({ icon: "info", title: "Información", html });
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener la información." });
      }
    });
  },

  esc: (v) =>
    String(v ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;"),
};
